import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import { apiRequest } from '../../utils';
import Icon from './Icon';

const CheckInCard = ({ active = true }) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!active) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await apiRequest('GET', '/check-in/qr');
        if (!cancelled) setData(res);
      } catch {
        if (!cancelled) setData(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [active]);

  if (!active) return null;
  if (loading) return null;
  if (!data || !data.qr_enabled) return null;
  if (data.attended) return null;

  return (
    <div className="checkin-card mx-3 mb-3">
      <div className="checkin-card__head">
        <div className="checkin-card__title">{t('checkInTitle')}</div>
        <div className="checkin-card__sub">{t('checkInSub')}</div>
      </div>
      {data.house_name && (
        <div
          className="checkin-card__house"
          style={{ color: data.house_color || undefined }}
        >
          {data.house_name}
        </div>
      )}
      <div className="checkin-card__qr">
        <QRCodeSVG
          value={data.qr_token}
          size={200}
          level="M"
          includeMargin={false}
        />
      </div>
      <div className="checkin-card__foot">
        <Icon name="info" theme="primary" className="me-1" />
        {t('checkInHint')}
      </div>
    </div>
  );
};

export default CheckInCard;
